<template>
  <div class="app-container">
    <div
      ref="filterContainer"
      class="filter-container"
    >
      <!-- 后退、前进、设置列 -->
      <table-operation2
        :init-table-column="masterList.initTableColumn"
        :table-columns.sync="masterList.tableColumns"
        :table-key="masterList.tableKey"
        :table-index.sync="masterList.tableIndex"
        :search-condition.sync="masterList.tableQuery"
        :table-transfer-name="getTransferName()"
        @reloadData="requestData()"
      />
    </div>
    <div class="container-box">
      <!-- 查询条件 -->
      <div ref="searchCondition">
        <el-row :gutter="10">
          <el-col style="width:40px; padding-left:10px;">
            <el-button type="text">
              查询：
            </el-button>
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.schemeNo"
              placeholder="请输入方案编号"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.schemeName"
              placeholder="请输入方案名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <el-input
              v-model="masterList.tableQuery.userName"
              placeholder="请输入人员名称"
              style="width:100%"
              clearable
              @keyup.enter.native="searchData()"
            />
          </el-col>
          <el-col :span="3">
            <date-select :search-date.sync="masterList.tableQuery.searchDate" />
          </el-col>
          <el-col :span="2">
            <el-button
              type="primary"
              @click="searchData()"
            >
              查询
            </el-button>
          </el-col>
        </el-row>
      </div>

      <!-- 数据列表 -->
      <custom-table2
        :ref="masterList.tableKey"
        style="margin-top:5px"
        :data-obj="masterList"
        :table-key="masterList.tableKey"
        :table-columns="masterList.tableColumns"
        :table-data="masterList.tableData"
        :loading="masterList.tableLoading"
        :search-condition.sync="masterList.tableQuery"
        :data-total="masterList.tableDataTotal"
        :table-contextmenu="masterList.tableContextmenu"
        :table-custom-height="tableHeight"
        :total-amount="totalAmount"
        :is-show-total="isShowTotal"
        is-index-field
        is-paging
        @edit="editFun(arguments)"
        @view="viewFun(arguments)"
        @dblclick="viewFun(arguments)"
        @reloadData="loadTableData()"
        @export="batchExport(masterList)"
        @getTotal="totalFun"
      />
    </div>
    <!--修改 查看-->
    <edit-view-dialog
      :data-id="id"
      :event-type="eventType"
      :dialog-title="dialogAddEditTitle"
      :dialog-visible.sync="dialogAddEditVisible"
      :master-table-key="masterList.tableKey"
      @reloadData="loadTableData()"
    />
  </div>
</template>

<script>
// Table操作组件（后退、前进、列设置）
import TableOperation2 from '@/components/TableOperation2'
// 列表设置tableKeyMixin
import tableOperationMixin2 from '@/mixin/tableOperationMixin2'
// 导出 batchExportMixin
import batchExportMixin2 from '@/mixin/batchExportMixin2'
// 自定义Table
import CustomTable2 from '@/components/CustomTable2'
// 定义表头颜色，高度，查询，获取数据Mixin
import tableCustomMixin2 from '@/mixin/tableCustomMixin2'
// 日期选择
import DateSelect from '@/components/DateSelect'
// 修改 查看
import editViewDialog from './components/editViewDialog'
// API
import { loadSalaryActivityPerformanceInfoListDataApi, exportSalaryActivityPerformanceInfoListDataApi, sumSalaryActivityPerformanceInfoListDataApi } from '@/api/v2/salaryActivityPerformanceInfo'

export default {
  name: 'SalaryActivityPerformanceInfoView',
  components: {
    CustomTable2,
    TableOperation2,
    DateSelect,
    editViewDialog
  },
  mixins: [tableCustomMixin2, tableOperationMixin2, batchExportMixin2],
  data () {
    return {
      // 主列表
      masterList: {
        initTableColumn: [], // Table初始化列
        tableColumns: [], // Table列
        tableKey: 'salary_activity_performance_info_master', // Table Key
        tableIndex: 0, // Table Index
        tableLoading: false, // Table加载状态
        tableData: [], // Table数据
        tableDataTotal: 0, // Table总数据条数
        // Table右键
        tableContextmenu: [
          {
            permissionSigns: ['salary_activity_performance_info_set'],
            prop: 'edit',
            label: '设置计算绩效',
            method: 'edit'
          },
          {
            permissionSigns: ['salary_activity_performance_info_view'],
            prop: 'view',
            label: '查看',
            method: 'view'
          },
          {
            permissionSigns: ['salary_activity_performance_info_export'],
            prop: 'export',
            label: '导出',
            method: 'export'
          }
        ],
        tableQuery: {
          // 页数
          page: 1,
          // 每页条数
          limit: 50,
          // 右键筛选字段
          contextMenuWrap: [],
          // 排序字段
          sortProp: '',
          // 排序类型
          sortOrder: '',
          // 查询条件
          userName: '',
          schemeNo: '',
          schemeName: '',
          searchDate: '',
          activitySub: 1
        }
      },
      // 合计结果
      totalAmount: 0,
      // 合计显示
      isShowTotal: false,
      id: null,
      eventType: '',
      dialogAddEditVisible: false,
      dialogAddEditTitle: '',

    }
  },
  created () {
    // 初始化主列表Table列
    this.masterList.initTableColumn = [
      { prop: 'rowNumber', label: '序号', width: 80 },
      { prop: 'id', label: '单据编号', filterColumn: 'tsapi.id', width: 120 },
      { prop: 'sellId', label: '报告编号', filterColumn: 'tsapi.sell_id', width: 120 },
      { prop: 'performanceId', label: '发放编号', filterColumn: 'tsapi.performance_id', width: 120 },
      { prop: 'schemeNo', label: '方案编号', filterColumn: 'ts.project_no', width: 200 },
      { prop: 'schemeName', label: '方案名称', filterColumn: 'ts.name', width: 200 },
      { prop: 'isPerformanceValue', label: '是否计算绩效', filterColumn: 'tsapi.is_performance', filterValue: 'isPerformance', filterArray: [{ label: '未设置', value: 0 },{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 140 },
      { prop: 'activityDate', label: '活动日期', filterColumn: 'tcbs.activity_date', width: 120, isBetween: true },
      { prop: 'feedbackTime', label: '最后审核时间', filterColumn: 'tcbs.feedback_time', width: 150, isBetween: true },
      { prop: 'provinceName', label: '省区', filterColumn: 'tcbs.province_name', width: 120 },
      { prop: 'cityName', label: '城市', filterColumn: 'tcbs.city_name', width: 120 },
      { prop: 'fieldTypeValue', label: '场次', filterColumn: 'tcbs.field_type', filterValue: 'fieldType', filterArray: [{ label: '一场半天', value: 1 }, { label: '一场一天', value: 2 }], width: 120 },
      { prop: 'userName', label: '人员名称', filterColumn: 'tr.name', width: 120 },
      { prop: 'isDisplayValue', label: '是否有展陈', filterColumn: 'tsapi.is_display', filterValue: 'isDisplay', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 160 },
      { prop: 'displayAmount', label: '展陈数量', filterColumn: 'tsapi.display_amount', width: 120 },
      { prop: 'isMonthValue', label: '是否月度人员', filterColumn: 'tsapi.is_month', filterValue: 'isMonth', filterArray: [{ label: '是', value: 1 }, { label: '否', value: 2 }], width: 160 },
      { prop: 'performanceAmount', label: '绩效金额', filterColumn: 'tsapi.performance_amount', width: 160, allowSum: true },
      { prop: 'deductAmount', label: '绩效扣除金额', filterColumn: 'tsapi.deduct_amount', width: 160, allowSum: true },
      { prop: 'realPerformanceAmount', label: '实发绩效金额', filterColumn: 'tsapi.real_performance_amount', width: 160, allowSum: true },
      { prop: 'deductDescription', label: '绩效扣除说明', filterColumn: 'tsapi.deduct_description', width: 160 },
      { prop: 'auditOpinion', label: '审核意见', filterColumn: 'tsapi.audit_opinion', width: 160 },
      { prop: 'activityWarning', label: '预警信息', filterColumn: 'tsapi.activity_warning', width: 160 },
      { prop: 'statusValue', label: '发放状态', filterColumn: 'tsapi.status', filterValue: 'status', filterArray: [{ label: '未发放', value: 1 }, { label: '发放中', value: 2 }, { label: '已发放', value: 3 }, { label: '不发放', value: 4 }], width: 120 },
      { prop: 'remark', filterColumn: 'tsapi.remark', label: '备注', width: 220 },
      { prop: 'operatorName', filterColumn: 'tsapi.operator_name', label: '操作人', width: 120 },
      { prop: 'operationTime', filterColumn: 'tsapi.operation_time', label: '操作时间', width: 150, isBetween: true }
    ]
    // 默认主列表Table列
    this.getInitTableColumns()
    this.loadTableData()
  },
  methods: {
    // 请求数据
    requestData () {
      let _this = this;
      loadSalaryActivityPerformanceInfoListDataApi(_this.masterList.tableQuery).then(response => {
        const { data } = response;
        this.handleData(data.list || [])
        this.masterList.tableDataTotal = data.total || 0
      }).catch()
    },
    // 合计方法
    totalFun (fieldColumn, computedTotalObj) {
      let _this = this;
      _this.masterList.tableQuery.sumField = computedTotalObj.filterColumn
      sumSalaryActivityPerformanceInfoListDataApi(_this.masterList.tableQuery).then((response) => {
        _this.isShowTotal = true
        _this.totalAmount = response.data || 0
      }).catch()
    },
    // 修改
    editFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要修改的活动报告人员绩效信息', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'edit'
      _this.dialogAddEditTitle = '修改活动报告人员绩效信息'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 查看
    viewFun (args) {
      let _this = this;
      if (!args[0]) {
        _this.$message({ message: '请选择要查看的活动报告人员绩效信息', type: 'warning' })
        return
      }
      _this.id = args[0].id
      _this.eventType = 'view'
      _this.dialogAddEditTitle = '查看活动报告人员绩效信息'
      _this.dialogAddEditVisible = !_this.dialogAddEditVisible
    },
    // 导出数据API
    exportByPage () {
      let _this = this;
      exportSalaryActivityPerformanceInfoListDataApi(_this.exportObj).then(response => {
        const { data } = response
        _this.$store.dispatch('message/settingExportSuccess', { exportSuccess: data.createFileResult, url: data.filePath })
      })
    }
  }
}
</script>
